import {TooltipBaseModel} from "../tooltip-base/tooltip-base.model";
import {Check} from "@sparkware/app-utils";
import {IRegularTooltipsContainer} from "./regular-tooltips-container.interface";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {IRegularTooltipOptions} from "./regular-tooltip-options.interface";
import {makeObservable} from "mobx";


export class RegularTooltipModel extends TooltipBaseModel<IRegularTooltipOptions> {

    constructor(tooltipsContainer: IRegularTooltipsContainer,
                services: IServiceFactoryExtended,
                options: IRegularTooltipOptions) {
        super(services, options);

        makeObservable(this);
        this.tooltipsContainer = tooltipsContainer;

    }

    readonly tooltipsContainer: IRegularTooltipsContainer;

    protected _getElementToAttach(): HTMLElement | null {
        if(Check.isString(this.options.attachTo)) {
            return this.services.dom.querySelector(this.options.attachTo) as HTMLElement;
        }

        return this.options.attachTo;
    }

    closeTooltip(): void {
        super.closeTooltip();
        this.tooltipsContainer.removeTooltip(this);
    }
}



